import React from 'react';

import {
  Grid,
  Button,
  Typography,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const criteriaForm = (props) => {
  const buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Search
    </Button>
  );

  return (
    <React.Fragment>
      <Typography>
        Some fields may be pre-selected depending on the site you are viewing.
        You cannot deselect them.
      </Typography>
      <br />
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="from_age"
            config={props.inputs.from_age}
            changed={event => props.inputChangedHandler(event, 'from_age')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="to_age"
            config={props.inputs.to_age}
            changed={event => props.inputChangedHandler(event, 'to_age')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="from_height"
            config={props.inputs.from_height}
            changed={event => props.inputChangedHandler(event, 'from_height')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="to_height"
            config={props.inputs.to_height}
            changed={event => props.inputChangedHandler(event, 'to_height')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="marital_status"
            config={props.inputs.marital_status}
            changed={event => props.inputChangedHandler(event, 'marital_status')}
            loadOptions={asyncSelectData.getMaritalStatusOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="caste"
            config={props.inputs.caste}
            changed={event => props.inputChangedHandler(event, 'caste')}
            loadOptions={asyncSelectData.getCasteOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="profession"
            config={props.inputs.profession}
            changed={event => props.inputChangedHandler(event, 'profession')}
            loadOptions={() => asyncSelectData.getOptionConstants('profession')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="work_profile"
            config={props.inputs.work_profile}
            changed={event => props.inputChangedHandler(event, 'work_profile')}
            loadOptions={asyncSelectData.getWorkProfile}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="qualification"
            config={props.inputs.qualification}
            changed={event => props.inputChangedHandler(event, 'qualification')}
            loadOptions={() => asyncSelectData.getOptionConstants('qualification')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="study_field"
            config={props.inputs.study_field}
            changed={event => props.inputChangedHandler(event, 'study_field')}
            loadOptions={asyncSelectData.getStudyField}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="degree"
            config={props.inputs.degree}
            changed={event => props.inputChangedHandler(event, 'degree')}
            loadOptions={asyncSelectData.getDegrees}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="from_india"
            config={props.inputs.from_india}
            changed={event => props.inputChangedHandler(event, 'from_india')}
            loadOptions={asyncSelectData.getFromIndiaOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="country"
            config={props.inputs.country}
            changed={event => props.inputChangedHandler(event, 'country')}
            loadOptions={asyncSelectData.getCountryOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="city"
            config={props.inputs.city}
            changed={event => props.inputChangedHandler(event, 'city')}
            loadOptions={asyncSelectData.getCityOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="bureau"
            config={props.inputs.bureau}
            changed={event => props.inputChangedHandler(event, 'bureau')}
            loadOptions={asyncSelectData.getBureauOptions}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="income"
            config={props.inputs.income}
            changed={event => props.inputChangedHandler(event, 'income')}
            loadOptions={asyncSelectData.getIncome}
          />
        </Grid>
        {props.user.is_premium && (
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="is_premium"
            config={props.inputs.is_premium}
            changed={event => props.inputChangedHandler(event, 'is_premium')}
            loadOptions={asyncSelectData.getPremiumOptions}
          />
        </Grid>
        )}
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default criteriaForm;



// WEBPACK FOOTER //
// ./src/search/components/CriteriaForm.js